// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61ddf74a","54":"c7008f86","92":"d1afe33b","108":"111263bc","154":"110a3ef8","165":"e4673fe0","580":"10e58b26","605":"e21494e7","674":"bd80247d","787":"b72bc5b4"}[chunkId] + ".chunk.js";
};